import './styles/styles.scss';
import { renderPage } from '../page';
import OrderViewerErrorPage from './orderViewerErrorPage';
import OrderViewerPage from './orderViewerPage';
import createStore from './stores/storeFactory';
import { OrderViewerError } from './typing/enums';
import { IOrderViewerViewModel } from './typing/orderViewerViewModel';

(function () {
	window.firstPageLoad = () => {
		const modelJson = (document.getElementById('OrderViewerModelJson') as HTMLInputElement)?.value;
		if (!modelJson) {
			throw new Error('Order model is not found.');
		}

		const model: IOrderViewerViewModel = JSON.parse(modelJson);
		const store = createStore(window.basePath, model);
		const page = model.error === OrderViewerError.None ? <OrderViewerPage /> : <OrderViewerErrorPage />;

		renderPage(page, store);
	};
})();
